import { Product } from "~/entities/product/types";

export const productNameFrom = (product: Product, nowrap = true): string => {
  const hyphenatedStr = /(?=\S*['-])([a-zA-Z'-]+)/g;
  let name = product.name;

  if (nowrap) {
    name = product.name
      .split(" ")
      .map((word) =>
        word.replace(
          hyphenatedStr,
          `<span class="whitespace-nowrap">${word}</span>`,
        ),
      )
      .join(" ");
  }

  return [product.mill?.name, product.styleCode, name].join(" ");
};
